import React from "react";
import "./Payroll.css";
import Topbar from "../../../Components/Topbar/Topbar";
import Navbar from "../../../Components/Navbar/Navbar";
import Banner from "../../../Components/Banner/Banner";
import Footer from "../../../Components/Footer/Footer";
import GetInTouch from "../../Home/Components/GetInTouch/GetInTouch";
import Section1 from "./Components/Section1/Section1";
const PayrollService = () => {
  return (
    <div className="irs__audit_service">
      <Topbar />
      <Navbar />
      <Banner content="Payroll Services" />
      <Section1 />
      <GetInTouch />
      <Footer />
    </div>
  );
};

export default PayrollService;
